import React from 'react';
import useCountUp from '../hooks/useCountUp';
import ObjectFloat from './objects/ObjectFloat';
import '../styles/Home.css';

interface StatDef {
  target: number;
  suffix: string;
  label: string;
}

const STATS: StatDef[] = [
  { target: 100, suffix: '+', label: 'Offers placed' },
  { target: 85, suffix: '%', label: 'Final-round conversion' },
  { target: 20, suffix: '+', label: 'Banks, funds & consultancies' }
];

const SHOTS = [
  {
    src: '/images/session-student.jpg',
    alt: 'Student on a 1-on-1 Zoom tutoring call with their interview prep tutor'
  },
  {
    src: '/images/session-notes.jpg',
    alt: 'Candidate taking notes during an online interview coaching session'
  },
  {
    src: '/images/session-tutor.jpg',
    alt: 'Tutor presenting charts and giving feedback over a video call'
  }
];

const QUOTES = [
  {
    quote:
      'Got into a bulge bracket S&T spring week as a first-year. It set me up perfectly for sophomore summer.',
    who: 'S&T spring week, bulge-bracket bank'
  },
  {
    quote: 'Secured a J.P. Morgan summer analyst seat from a non-target school.',
    who: 'IB summer analyst, J.P. Morgan'
  },
  {
    quote: 'They helped with every single step to the offer.',
    who: 'Fixed income seat, multi-strategy fund'
  }
];

const CountStat: React.FC<StatDef> = ({ target, suffix, label }) => {
  const { ref, value } = useCountUp(target);
  return (
    <div className="stat">
      <span className="stat-value" ref={ref}>
        {value}
        {suffix}
      </span>
      <span className="stat-label">{label}</span>
    </div>
  );
};

const Record: React.FC = () => {
  return (
    <section id="record" className="section record">
      <div className="obj-spot spot-bars" aria-hidden="true"><ObjectFloat slug="bars" /></div>
      <div className="container">
        <div className="section-head" data-reveal>
          <p className="section-eyebrow">The record</p>
          <h2 className="section-title">
            We&apos;ve already placed 100+ offers since 2014, and you can be
            the next one.
          </h2>
        </div>

        <div className="stats-row" data-reveal>
          {STATS.map(stat => (
            <CountStat key={stat.label} {...stat} />
          ))}
        </div>

        <div className="demo-grid record-shots">
          {SHOTS.map((shot, index) => (
            <figure
              key={shot.src}
              className="demo-figure"
              data-reveal
              style={{ ['--reveal-delay' as string]: `${index * 0.1}s` }}
            >
              <img src={shot.src} alt={shot.alt} loading="lazy" width={1200} height={800} />
            </figure>
          ))}
        </div>

        <div className="quotes-grid">
          {QUOTES.map((entry, index) => (
            <blockquote
              key={entry.who}
              className="quote-card"
              data-reveal
              style={{ ['--reveal-delay' as string]: `${index * 0.1}s` }}
            >
              <p>“{entry.quote}”</p>
              <cite>{entry.who}</cite>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Record;
